<template>
  <div class="Purchase" style="background-color:white">
    <el-row style="padding-top:10px">
      <el-col :span="24">
        <el-button size="small" class="btn" type="primary" v-if="show.tj" @click="handleCreate">添加</el-button>
        <el-button class="btn" size="small" type="primary" v-if="show.tj" @click="handleSumbit">提交</el-button>
        <el-button class="btn" size="small" type="primary" v-if="show.sh" @click="examine">审核</el-button>
        <el-form :inline="true" ref="deviceInfo" :model="deviceInfo" class="demo-form-inline"
          style="float:right!important">
          <el-form-item :label="lable.statue">
            <el-select v-model="deviceInfo.status" filterable clearable placeholder="请选择状态" style="width:120px">
              <el-option v-for="item in statues" :key="item.id" :label="item.name" :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="日期">
            <el-date-picker v-model="deviceInfo.date" type="daterange" range-separator="至" start-placeholder="开始日期"
              end-placeholder="结束日期">
            </el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-input v-model="deviceInfo.content" auto-complete="off" placeholder="请输入搜索内容"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button size="small" type="primary" @click="getPurchaseClick">查询</el-button>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="24">
        <el-table :header-cell-style="{ textAlign: 'center', background: '#eff3f6' }"
          :cell-style="{ textAlign: 'center' }" ref="multipleTable" :data="tableData" tooltip-effect="dark"
          style="width: 100%;text-align: center" stripe>
          <el-table-column type="selection" width="55"> </el-table-column>
          <el-table-column :label="lable.index" type="index"  show-overflow-tooltip>
            <template slot-scope="scope">
              <span>{{ scope.$index + (pageIndex - 1) * pagesize + 1 }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="id" :label="lable.id">
            <template slot-scope="scope" show-overflow-tooltip>
              <el-link :underline="false" @click="onClick(scope.row)" style="color: #4095E5;text-decoration: none;">
                {{ scope.row.id }}
              </el-link>
            </template>
          </el-table-column>
          <el-table-column prop="deviceTypeName" :label="lable.deviceTypeName" show-overflow-tooltip>
          </el-table-column>
          <el-table-column prop="deviceName" :label="lable.deviceName" show-overflow-tooltip>
          </el-table-column>
          <el-table-column prop="num" :label="lable.num" show-overflow-tooltip>
          </el-table-column>
          <el-table-column prop="producer" :label="lable.producer" show-overflow-tooltip>
          </el-table-column>
          <el-table-column prop="deviceMany" :label="lable.deviceMany" show-overflow-tooltip>
          </el-table-column>
          <el-table-column prop="companyName" :label="lable.companyName" show-overflow-tooltip>
          </el-table-column>
          <el-table-column prop="createTime" :label="lable.createTime" show-overflow-tooltip>
          </el-table-column>
          <el-table-column prop="statue" :label="lable.statue" show-overflow-tooltip>
            <template slot-scope="scope">
              <span v-if="scope.row.statue == '1'" style="color:#4095E5">待提交</span>
              <span v-else-if="scope.row.statue == '2'" style="color:gray">待审核</span>
              <span v-else-if="scope.row.statue == '3'" style="color:yellowgreen">待验收</span>
              <span v-else-if="scope.row.statue == '0'" style="color:red">驳回</span>
              <span v-else-if="scope.row.statue == '4'" style="color:yellowgreen">验收完成</span>
              <span v-else style="color:blueviolet">待审核</span>
            </template>
          </el-table-column>
          <el-table-column prop="cz" :label="lable.cz" show-overflow-tooltip>
            <template slot-scope="scope">
              <el-button v-if="(scope.row.statue == '0' || scope.row.statue == '1') && show.tj"
                @click="addPurchase(scope.row)" type="text" size="small">编辑</el-button>
              <el-button v-if="(scope.row.statue == '0' || scope.row.statue == '1') && show.sc"
                @click="delPurchase(scope.row)" type="text" size="small">删除</el-button>
              <el-button @click="selectClick(scope.row)" type="text" size="small">详情</el-button>
              <el-button v-if="scope.row.statue == '4'" @click="yulan(scope.row)" type="text"
                size="small">附件预览</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
      <!--分页工具条-->
      <el-col :span="24" class="toolbar" style="margin-top:5px;height: 35px;">
        <el-pagination v-if="tableData.length > 0" @size-change="handleSizeChange" @current-change="handleCurrentChange"
          :page-sizes="[10, 20, 50, 100]" :page-size="pagesize" layout="total, sizes, prev, pager, next, jumper"
          :total="total" style="float:right">
        </el-pagination>
      </el-col>
    </el-row>
    <!-- <Create @handleCreate="handleCreate"></Create> -->
    <!-----------------------------------------------------------------------添加采购计划弹出框------------------------------------------------------------------------------>

    <el-dialog :visible.sync="dialogFormVisible" title="添加采购计划" :close-on-click-modal="false"
      :close-on-press-escape="false"
      style="width:60% !important;margin-left: 300px;">
      <el-form :model="questionForm" ref="dataForm" label-position="left" label-width="100px"
        style="width: 80%; margin-left:30px;">
        <el-form-item :label="lable.deviceTypeName">
          <el-cascader v-model="questionForm.sblb" style="width:100%" :options="options" :props="props"
            :show-all-levels="false" filterable></el-cascader>
        </el-form-item>
        <el-form-item :label="lable.deviceName">
          <el-input :placeholder="'请输入' + lable.deviceName" v-model="questionForm.deviceName" />
        </el-form-item>
        <el-row>
          <el-col :span="12">
            <el-form-item label="量程">
              <el-input placeholder="请输入量程" v-model="questionForm.lc" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="精度等级" style="margin-left:10px;" label-width="70px">
              <el-input placeholder="请输入精度" v-model="questionForm.jddj" />
            </el-form-item>
          </el-col>
        </el-row>

        <el-form-item :label="lable.num">
          <el-input :placeholder="'请输入采购' + lable.num" oninput="value=value.replace(/[^\d]/g,'')"
            v-model="questionForm.num" />
        </el-form-item>
        <el-form-item :label="lable.producer">
          <el-input :placeholder="'请输入' + lable.producer" v-model="questionForm.producer" />
        </el-form-item>
        <el-row>
          <el-col :span="12">
            <el-form-item :label="lable.deviceMany">
              <el-input :placeholder="'请输入' + lable.deviceMany" v-model="questionForm.deviceMany" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="税额" style="margin-left:10px;" label-width="70px">
              <el-input placeholder="请输入税额" v-model="questionForm.amount" />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <el-row>
        <el-col :span="8">
          <el-button type="primary" v-preventReClick @click="submit()">提交</el-button>
        </el-col>
        <el-col :span="8">
          <el-button type="primary" v-preventReClick @click="preserve()">保存</el-button>
        </el-col>
        <el-col :span="8">
          <el-button @click=cancel>取消</el-button>
        </el-col>
      </el-row>
    </el-dialog>

    <!--------------------------------------------------------------------采购计划提交弹出 --------------------------------------------------------------------------------------->
    <el-dialog :visible.sync="dialogSubmit" title="采购计划提交" :close-on-click-modal="false"
      :close-on-press-escape="false"
      style="width: 60% !important;margin-left:350px;">
      <el-form :model="questionForm" ref="dataForm" label-position="left" label-width="100px"
        style="width: 80%; margin-left:30px;">

        <el-form-item :label="lable.id">
          <el-input placeholder="cj20220100345" :readonly="true" v-model="questionForm.id" />
        </el-form-item>
        <el-form-item :label="lable.deviceTypeName">
          <!-- <el-select v-model="questionForm.sblb" style="width: 100%" placeholder="请选择">
            <el-option v-for="item in options" :key="item.id" :label="item.deviceTypeName" :value="item.id">
            </el-option>
          </el-select> -->
          <el-cascader v-model="questionForm.sblb" style="width:100%" :options="options" :props="props"
            :show-all-levels="false" filterable></el-cascader>
        </el-form-item>
        <el-form-item :label="lable.deviceName">
          <el-input :placeholder="'请输入' + lable.deviceName" v-model="questionForm.deviceName" />
        </el-form-item>
        <el-row>
          <el-col :span="12">
            <el-form-item label="量程">
              <el-input placeholder="请输入量程" v-model="questionForm.lc" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="精度等级" style="margin-left:10px;" label-width="70px" prop="otherAnswer2">
              <el-input placeholder="请输入精度" v-model="questionForm.jddj" />
            </el-form-item>
          </el-col>
        </el-row>

        <el-form-item :label="lable.num">
          <el-input :placeholder="'请输入' + lable.num" v-model="questionForm.num" />
        </el-form-item>
        <el-form-item :label="lable.producer">
          <el-input :placeholder="'请输入' + lable.producer" v-model="questionForm.producer" />
        </el-form-item>
        <el-row>
          <el-col :span="12">
            <el-form-item :label="lable.deviceMany">
              <el-input :placeholder="'请输入' + lable.deviceMany" v-model="questionForm.deviceMany" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="税额" style="margin-left:10px;" label-width="70px" prop="otherAnswer2">
              <el-input placeholder="请输入税额" v-model="questionForm.amount" />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <el-row>
        <el-col :span="12">
          <el-button type="primary" v-preventReClick @click="createData()">提交</el-button>
        </el-col>
        <el-col :span="12">
          <el-button type="primary" v-preventReClick @click="cancel()">取消</el-button>
        </el-col>
      </el-row>
    </el-dialog>

    <!----------------------------------------------------------------------------------------   采购计划审核弹出 ---------------------------------------------------------------->
    <el-dialog :visible.sync="dialogExamine" :close-on-click-modal="false"
      :close-on-press-escape="false" title="采购计划审核"
      style="width: 60% !important;margin-left:350px;">
      <el-form :model="questionForm" ref="dataForm" label-position="left" label-width="100px"
        style="width: 80%; margin-left:30px;">
        <el-form-item :label="lable.id" prop="correctAnswer">
          <el-input :readonly="true" v-model="questionForm.id" />
        </el-form-item>
        <el-form-item style="width: 100%" :label="lable.deviceTypeName">
          <el-cascader v-model="questionForm.sblb" style="width:100%" :options="options" :props="props"
            :show-all-levels="false" filterable></el-cascader>
        </el-form-item>
        <el-form-item :label="lable.deviceName">
          <el-input :readonly="true" v-model="questionForm.deviceName" />
        </el-form-item>
        <el-row>
          <el-col :span="12">
            <el-form-item label="量程">
              <el-input :readonly="true" v-model="questionForm.lc" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="精度等级" style="margin-left:10px;" label-width="70px">
              <el-input :readonly="true" v-model="questionForm.jddj" />
            </el-form-item>
          </el-col>
        </el-row>

        <el-form-item :label="lable.num">
          <el-input :readonly="true" v-model="questionForm.num" />
        </el-form-item>
        <el-form-item :label="lable.producer">
          <el-input :readonly="true" v-model="questionForm.producer" />
        </el-form-item>
        <el-row>
          <el-col :span="12">
            <el-form-item :label="lable.deviceMany">
              <el-input :readonly="true" v-model="questionForm.deviceMany" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="税额" style="margin-left:10px;" label-width="70px">
              <el-input :readonly="true" v-model="questionForm.amount" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item :label="lable.companyName">
          <el-input :readonly="true" v-model="questionForm.companyName" />
        </el-form-item>
        <el-form-item label="审批理由" prop="reject">
          <el-input placeholder="请输入原因" v-model="questionForm.reject" />
        </el-form-item>
      </el-form>
      <el-row>
        <el-col :span="12">
          <el-button type="primary" v-preventReClick @click="examineCG">通过</el-button>
        </el-col>
        <el-col :span="12">
          <el-button type="danger" v-preventReClick @click="examineCG1">驳回</el-button>
        </el-col>
      </el-row>
    </el-dialog>
    <!--------------------------------------------------------------------------------------采购计划详情弹出 ---------------------------------------------------------------->
    <el-dialog :visible.sync="dialogFormVisible1" :close-on-click-modal="false"
      :close-on-press-escape="false" title="采购计划详情"
      style="width: 90% !important;margin-left:10%;">
      <el-form :model="questionForm" ref="dataForm" label-position="left" label-width="100px"
        style="width: 90%; margin-left:5%;">
        <el-row>
          <el-col :span="12">
            <el-form-item :label="lable.id" prop="id" style="width: 90%">
              <el-input :readonly="true" v-model="questionForm.id" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="lable.companyName">
              <el-input :readonly="true" v-model="questionForm.companyName" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item :label="lable.deviceTypeName" style="width: 90%">
              <el-input :readonly="true" v-model="questionForm.deviceTypeName" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="lable.deviceName">
              <el-input :readonly="true" v-model="questionForm.deviceName" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="量程" style="width: 90%">
              <el-input :readonly="true" v-model="questionForm.lc" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="精度等级">
              <el-input :readonly="true" v-model="questionForm.jddj" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item :label="lable.num" style="width: 90%">
              <el-input :readonly="true" v-model="questionForm.num" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="lable.producer">
              <el-input :readonly="true" v-model="questionForm.producer" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item :label="lable.deviceMany" style="width: 90%">
              <el-input :readonly="true" v-model="questionForm.deviceMany" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="税额">
              <el-input :readonly="true" v-model="questionForm.amount" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="验收人" style="width: 90%">
              <el-input :readonly="true" v-model="questionForm.userName" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="设备编码">
              <el-input :readonly="true" v-model="questionForm.sbbm" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="审批理由" prop="reject" style="width: 90%">
              <el-input :readonly="true" v-model="questionForm.reject" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="保管员">
              <el-input :readonly="true" v-model="questionForm.bgy" />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <el-button type="primary" @click="dialogFormVisible1 = false">确认</el-button>
    </el-dialog>
    <el-dialog :title="previewTitle" :visible.sync="docxdialog" style="margin-top:-50px">
      <FilePreview ref="filePreview" />
    </el-dialog>
  </div>
</template>

<script>
import {
  findAllPurchaseInformation, addPurchaseInformation, treeCompany,
  submitPurchaseInformation, examinePurchaseInformation, deletePurchaseInformation, selectAllstatus, selectTreeDeviceType, findByModule
} from "../../api/api";
import FilePreview from '../../components/preview/FilePreview.vue'

export default {
  name: "Purchase",
  components: {
    "FilePreview": FilePreview,
  },
  data() {
    return {
      show: {
        tj: false,
        sc: false,
        xg: false,
        sh: false
      },
      lable: {},
      tableData: [],
      multipleSelection: [],
      deviceInfo: {
        status: '',
        date: [],
        content: ''
      },
      previewTitle: '',
      docxdialog: false,
      dialogFormVisible: false,
      dialogFormVisible1: false,
      dialogExamine: false,
      dialogSubmit: false,
      questionForm: {
        statue: ''
      },
      props: {
        label: 'deviceTypeName',
        value: 'id',
        children: 'deviceTypes',
        expandTrigger: 'click',
        emitPath: false
      },
      props1: {
        label: 'companyName',
        value: 'companyCode',
        children: 'zcompany',
        expandTrigger: 'click',
        emitPath: false
      },
      statues: [],
      sout: '',
      total: 0,
      pageIndex: 1,
      pagesize: 10,
      data: [],
      options: [],
      companyOptions: [],
    };
  },

  methods: {
    onClick(row) {
      this.questionForm = row;
      this.dialogFormVisible1 = true;
    },
    cancel() {
      this.getPurchase();
      this.dialogFormVisible = false;
      this.dialogSubmit = false;
    },
    selectClick(row) {
      this.questionForm = row;
      this.dialogFormVisible1 = true;
    },
    //提交采购计划
    createData() {
      var userinfo = JSON.parse(localStorage.getItem("user"))
      this.questionForm.userId = userinfo.userId
      submitPurchaseInformation(this.questionForm).then(datas => {
        // debugger
        let { status, message } = datas;
        if (status == 400) {
          this.$message({
            message: message,
            type: "error"
          });
        } else if (status == 200) {
          this.getPurchase();
          this.dialogSubmit = false;
          this.$message({
            message: "添加成功",
            type: "success"
          });
        } else {
          this.$message({
            message: "请求错误",
            type: "error"
          });
        }
      });

    },
    delPurchase(row) {
      this.$confirm('此操作将永久删除该信息, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        var userinfo = JSON.parse(localStorage.getItem("user"))

        var map = {
          id: row.id,
          userId: userinfo.userId
        }
        deletePurchaseInformation(map).then(datas => {
          let { status, message } = datas;
          if (status == 400) {
            this.$message({
              message: message,
              type: "error"
            });
          } else if (status == 200) {
            this.getPurchase();
            this.$message({
              message: "删除成功",
              type: "success"
            });
          } else {
            this.$message({
              message: "请求错误",
              type: "error"
            });
          }
        });
      })
    },
    //构建保存采购计划参数
    preserve() {
      this.questionForm.statue = 1;
      this.insert(this.questionForm);
    },
    //构建提交采购计划参数
    submit() {
      this.questionForm.statue = 2;
      this.insert(this.questionForm);
    },
    handleCreate() {
      this.questionForm = {};
      this.dialogFormVisible = true;
    },
    handleSumbit() {
      this.questionForm = {};
      let currentSelect = this.$refs.multipleTable.selection;
      if (currentSelect.length > 1) {
        this.$message.error("只能选择一条信息"); // .....失败信息
      } else if (currentSelect.length == 1) {
        if (currentSelect[0].statue == 1 || currentSelect[0].statue == 0) {
          this.questionForm = _.cloneDeep(currentSelect[0]);
          this.dialogSubmit = true;
        } else {
          this.$message.error("请选择未提交的采购信息"); // .....失败信息
        }
      } else {
        this.$message.error("请选择设备"); // .....失败信息
      }
    },
    addPurchase(row) {

      this.questionForm = _.cloneDeep(row);
      this.dialogSubmit = true;
    },
    examine() {
      this.questionForm = {};
      let currentSelect = this.$refs.multipleTable.selection;
      if (currentSelect.length > 1) {
        this.$message.error("只能选择一条信息"); // .....失败信息
      } else if (currentSelect.length == 1) {
        if (currentSelect[0].statue != 2) {
          this.$message.error("请选择未审核的采购信息"); // .....失败信息
        } else {
          this.questionForm = _.cloneDeep(currentSelect[0]);
          this.dialogExamine = true;
        }
      } else {
        this.$message.error("请选择设备"); // .....失败信息
      }
    },
    yulan(row) {
      console.log(row)
      if (row.fjzl.substring(row.fjzl.lastIndexOf(".") + 1) == 'jpg' || row.fjzl.substring(row.fjzl.lastIndexOf(".") + 1) == 'png' || row.fjzl.substring(row.fjzl.lastIndexOf(".") + 1) == 'jpeg') {
        this.previewTitle = "图片预览"
      } else {
        this.previewTitle = "文件预览"
      }
      this.docxdialog = true
      this.$nextTick(() => {
        this.$refs.filePreview.showView(row.fjzl)
      })
      // this.downloadUtil.preview(row.path)
    },
    //构建参数
    examineCG() {
      this.questionForm.sout = 0;
      this.sh(this.questionForm);
    },
    //构建参数
    examineCG1() {
      this.questionForm.sout = 1;
      this.sh(this.questionForm);
    },
    sh(row) {
      var map = row;
      var userinfo = JSON.parse(localStorage.getItem("user"))
      map.userId = userinfo.userId
      examinePurchaseInformation(map).then(datas => {
        // debugger
        let { status, message } = datas;
        if (status == 400) {
          this.getPurchase();
          this.dialogExamine = false;
          this.$message({
            message: message,
            type: "warning"
          });
        } else if (status == 200) {
          this.getPurchase();
          this.dialogExamine = false;
          this.$message({
            message: "审核通过",
            type: "success"
          });
        } else {
          this.$message({
            message: "请求错误",
            type: "error"
          });
        }
      });
    },
    getTreeData(data) {
      for (let i = 0; i < data.length; i++) {
        if (data[i].deviceTypes.length < 1) {
          // 最后一级没有数据将children变成undefined
          data[i].deviceTypes = undefined;
        } else {
          // children不为空时继续调用该方法
          this.getTreeData(data[i].deviceTypes);
        }
      }
      return data;
    },
    getTreeData1(data) {
      for (let i = 0; i < data.length; i++) {
        if (data[i].zcompany.length < 1) {
          // 最后一级没有数据将children变成undefined
          data[i].zcompany = undefined;
        } else {
          // children不为空时继续调用该方法
          this.getTreeData1(data[i].zcompany);
        }
      }
      return data;
    },
    insert(row) {
      var userinfo = JSON.parse(localStorage.getItem("user"))

      var map = row;
      map.userId = userinfo.userId
      addPurchaseInformation(map).then(datas => {
        let { status, message } = datas;
        if (status == 400) {
          this.$message({
            message: message,
            type: "warning"
          });
        } else if (status == 200) {
          this.getPurchase();
          this.dialogFormVisible = false;
          this.$message({
            message: "添加成功",
            type: "success"
          });
        } else {
          this.$message({
            message: "请求错误",
            type: "error"
          });
        }
      });
    },
    findAllType() {
      selectTreeDeviceType().then(datas => {
        let { status, message, data } = datas;
        if (status == 200) {
          this.options = this.getTreeData(data);
        }
      });
    },
    findAllCompany() {
      treeCompany().then(datas => {
        let { status, message, data } = datas;
        if (status == 200) {
          this.companyOptions = this.getTreeData1(data);
        }
      });

    },
    findAllStatueType() {
      selectAllstatus().then(datas => {
        let { status, message, data } = datas;
        if (status == 200) {
          for (var i = 0; i < data.length; i++) {
            if (data[i].statusType == "采购管理") {
              this.statues.push({ name: data[i].statusName, id: data[i].statue });
            }
          }
        }
      });
    },
    getPurchaseClick(){
      this.pageIndex=1
      this.getPurchase()
    },
    //查找资料信息
    getPurchase() {
      var userinfo = JSON.parse(localStorage.getItem("user"))

      let map = {
        start: this.deviceInfo.date == null ? null : this.deviceInfo.date[0],
        end: this.deviceInfo.date == null ? null : this.deviceInfo.date[1],
        content: this.deviceInfo.content,
        status: this.deviceInfo.status,
        userId: userinfo.userId
      };
      findAllPurchaseInformation(map).then(datas => {
        let { status, message, data } = datas;
        if (status == 200) {
          if (data == null) { this.data = [] } else { this.data = data; }

          this.tableData = this.data.slice(
            (this.pageIndex - 1) * this.pagesize,
            this.pageIndex * this.pagesize
          );
          this.total = data.length;
        }
      });
    },
    //分页
    handleCurrentChange(val) {
      this.pageIndex = val;
      //contentdata是所有的数据，是一个大数组。使用.slice()方法可以将大数组切分
      //.slice()方法接受两个参数，开始和结束的值
      //这样得到的currentdata就是固定只有10个值的数组了，就可以用v-for展示啦
      this.scrapData = this.data.slice((this.pageIndex - 1) * this.pagesize, this.pageIndex * this.pagesize)
    },
    handleSizeChange(val) {
      this.pagesize = val;
      this.scrapData = this.data.slice((this.pageIndex - 1) * this.pagesize, this.pageIndex * this.pagesize)
    },
    findLable() {
      findByModule("采购管理").then(datas => {
        let { status, message, data } = datas;
        if (status == 200) {
          this.lable = data;
        }
      });
    },

  },
  created() {
    this.findLable();
    this.findAllType();
    this.findAllStatueType();
    this.getPurchase();
    this.findAllCompany();
    var userinfo = JSON.parse(localStorage.getItem("user"))
    var arr = userinfo.role.menuId.split(",");
    arr.forEach((i) => {
      if (i == "62") {
        this.show.tj = true;
      }
      if (i == "63") {
        this.show.sc = true;
      }
      if (i == "64") {
        this.show.xg = true;
      }
      if (i == "65") {
        this.show.sh = true;
      }
    })
  },
};
</script>
<style >
.el-checkbox__inner {
    border: 1px solid #606266!important;
}
</style>

<style scoped>
.el-input {
  width: 100%
}

.btn {
  float: left;
  margin-left: 5px;
}
</style>



// WEBPACK FOOTER //
// src/views/purchase/Purchase.vue